module.exports = __webpack_public_path__ + "img/bg_bottom.dfd17110.png";